"use client"
import { createContext, useCallback, useContext, useRef, useState } from "react"

interface ConfirmState {
  message: string
  resolve: (ok: boolean) => void
}

const ConfirmContext = createContext<(message: string) => Promise<boolean>>(async () => false)

export function useConfirm() {
  return useContext(ConfirmContext)
}

export function ConfirmProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<ConfirmState | null>(null)
  const resolveRef = useRef<((ok: boolean) => void) | null>(null)

  const confirm = useCallback((message: string) => {
    return new Promise<boolean>((resolve) => {
      resolveRef.current = resolve
      setState({ message, resolve })
    })
  }, [])

  const close = (ok: boolean) => {
    resolveRef.current?.(ok)
    resolveRef.current = null
    setState(null)
  }

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60">
          <div className="w-80 rounded-xl border border-gray-800 bg-gray-900 p-5">
            <p className="mb-5 whitespace-pre-line text-sm text-gray-200">{state.message}</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => close(false)}
                className="rounded px-3 py-1.5 text-sm text-gray-400 hover:bg-gray-800"
              >
                取消
              </button>
              <button
                onClick={() => close(true)}
                className="rounded bg-blue-700 px-3 py-1.5 text-sm text-white hover:bg-blue-600"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  )
}
